<template>
    <div>
        <div class="breadcrumb">
            <h1 style="color: #AC8400;">Claim Terms and Condition</h1>
        </div>

        <!-- Breadcrumbs -->
        <div style="padding: 10px; background-color: #F2F2F2">
            <router-link to="/dashboard">Dashboard</router-link> /
            <b>TBA</b> /
            <b>Terms and Condition</b>
        </div>
        <!-- End of breadcrumbs -->

        <div class="separator-breadcrumb border-top"></div>

        <div class="card" style="padding: 20px">
            <h1>Musafir</h1>
            <div class="row">
                <div class="col-md-6">
                    <TextInput label="Title" :modelValue="title" :required="true" :errorMessage="errorTitle"
                        :onChange="handleTitleChange" />
                </div>
            </div>
            <div class="form-group">
                <label>Content</label>
                <div id="app">
                    <ckeditor :editor="editor" v-model="content" :config="editorConfig"></ckeditor>
                    <small class="text-danger">{{ errorContent }}</small>
                </div>
            </div>
            <div class="form-group" style="margin-left: 10px;">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="active" name="status" class="custom-control-input" value="1"
                        v-model="status" @change="handleStatusChange($event)">
                    <label class="custom-control-label" for="active">Active</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="inactive" name="status" class="custom-control-input" value="0"
                        v-model="status" @change="handleStatusChange($event)">
                    <label class="custom-control-label" for="inactive">Inactive</label>
                </div>
            </div>

            <div class="d-flex justify-content-end w-100">
                <div v-if="!terms" class="mt-4">
                    <button class="btn btn-primary btn-rounded" @click="() => storeTerms()">Submit</button>
                </div>

                <div v-if="terms" class="mt-4">
                    <button class="btn btn-primary btn-rounded" @click="() => updateTerms()">Update</button>
                </div>

                <div v-if="terms" class="mt-4">
                    <button class="btn btn-dark btn-rounded ml-3" @click="() => previewTerms()">Preview</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getClaimByProduct, storeClaimTerms, updateClaimTerms } from "../../../services/ClaimService";
import TextInput from "../../../components/TextInput.vue";
import { getRequest } from "../../../services/RequestService";

export default {
    name: "tba-terms",

    components: {
        TextInput,
        ckeditor: CKEditor.component
    },

    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            content: "",
            title: "",
            status: false,
            terms: null,
            errorTitle: "",
            errorContent: "",
        };
    },

    methods: {
        async fetchClaimByProduct() {
            const response = await getClaimByProduct(6);

            if (response.data.success) {
                if (response.data.data == null) {
                    return;
                } else {
                    this.terms = response.data.data;
                    this.content = response.data.data.content;
                    this.title = response.data.data.title;
                    this.status = response.data.data.status;
                }
            }
        },

        validateRequest() {
            let hasError = false;

            this.errorTitle = "";
            this.errorContent = "";

            if (!this.title || this.title.trim() === "") {
                this.errorTitle = "Title is required";
                hasError = true;
            }

            if (!this.content || this.content.trim() === "") {
                this.errorContent = "Content is required";
                hasError = true;
            }

            return !hasError; // ✅ return true if valid, false if errors exist
        },

        async storeTerms() {
            if (!this.validateRequest()) return;

            const request = {
                title: this.title,
                content: this.content,
                status: this.status,
                product_id: 6
            }

            const response = await storeClaimTerms(request);

            if (response.data.success) {
                swal({
                    text: response.data.message,
                    icon: "success",
                    button: "OK"
                });
                this.fetchClaimByProduct();
            } else {
                swal({
                    text: response.data.message,
                    icon: "error",
                    button: "OK"
                });
            }
        },

        async updateTerms() {
            if (!this.validateRequest()) return;

            const request = {
                title: this.title,
                content: this.content,
                status: this.status,
                product_id: 6,
            }

            const response = await updateClaimTerms(request, this.terms.id);

            if (response.data.success) {
                swal({
                    text: response.data.message,
                    icon: "success",
                    button: "OK"
                });
                this.fetchClaimByProduct();
            } else {
                swal({
                    text: response.data.message,
                    icon: "error",
                    button: "OK"
                });
            }
        },

        handleStatusChange(event) {
            this.status = parseInt(event.target.value);
        },

        handleTitleChange(event) {
            this.title = event.target.value;
        },

        async previewTerms() {
            const url = `/claim/terms-and-conditions/${this.terms.id}/download`;

            try {
                const response = await getRequest(url, { responseType: 'blob' });

                if (response.status !== 200) {
                    throw new Error('Failed to fetch PDF');
                }

                console.log(response)

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.target = '_blank';
                link.click();
            } catch (err) {
                console.error("Error fetching PDF:", err);
            }
        },
    },

    async mounted() {
        this.fetchClaimByProduct();
    }
}
</script>